<script>
  import LayerOps from "./LayerOps.svelte";
</script>

<div class="left">
  <LayerOps />
</div>

<style>
  .left {
    background-color: rgb(77, 84, 124);
    /* float: left; */
    width: 20%;
    height: 100%;
  }
</style>
